import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";
import analyticsFilter1 from "../../../constants/analytics/analyticsFilter1";

const startDate = moment().utc().add(-29, "days").startOf("day").toISOString();
const endDate = moment().utc().endOf("day").toISOString();

export const analyticsSlice = createSlice({
  name: "analytics",
  initialState: {
    data: {
      globalFilter: {
        campaignIds: [],
        segmentIds: [],
        startDate: startDate,
        endDate: endDate,
        filters: [],
      },
      performance: {
        conversion: analyticsFilter1[0].value,
        engCount: analyticsFilter1[2].value,
        views: analyticsFilter1[3].value,
        time: analyticsFilter1[6].value,
        topCta: "all",
        topEng: "all",
        topEndScreens: "all",
        timeline: "totalView",
        topPages: "1",
      },
    },
    etc: {
      isGlobalFilterLoaded: true,
    },
  },
  reducers: {
    setAnalyticsData: (state, action) => {
      state.data = action.payload;
    },
    setConversion: (state, action) => {
      state.data.performance.conversion = action.payload;
    },
    setEngCount: (state, action) => {
      state.data.performance.engCount = action.payload;
    },
    setViews: (state, action) => {
      state.data.performance.views = action.payload;
    },
    setTime: (state, action) => {
      state.data.performance.time = action.payload;
    },
    setTopCta: (state, action) => {
      state.data.performance.topCta = action.payload;
    },
    setTopEng: (state, action) => {
      state.data.performance.topEng = action.payload;
    },
    setTopEndScreens: (state, action) => {
      state.data.performance.topEndScreens = action.payload;
    },
    setTimeline: (state, action) => {
      state.data.performance.timeline = action.payload;
    },
    setTopPages: (state, action) => {
      state.data.performance.topPages = action.payload;
    },
    setIsGlobalFilterLoaded: (state, action) => {
      state.etc.isGlobalFilterLoaded = action.payload;
    },
  },
});

export const {
  setAnalyticsData,
  setConversion,
  setEngCount,
  setViews,
  setTime,
  setTopCta,
  setTopEng,
  setTopEndScreens,
  setTimeline,
  setTopPages,
  setIsGlobalFilterLoaded,
} = analyticsSlice.actions;

export default analyticsSlice.reducer;
